import React from "react";
import { Button, Form, Input, Modal } from "antd";
import "./PaymentCancelModal.less";

interface ComponentProps {
  visible: boolean;
  submitCancelPayment: (reason?: string) => void;
  closeModal: () => void;
  isLoading: boolean;
}

export const PaymentCancelModal = (props: ComponentProps) => {
  const { visible, submitCancelPayment, closeModal, isLoading } = props;

  const [form] = Form.useForm<{ reason: string }>();

  return (
    <Modal
      className="payment-cancel-modal"
      visible={visible}
      title={
        <>
          <span>Вы действительно хотите отменить платеж?</span>
          <br />
          <span>Дальнейшие действия с платежом будут недоступны.</span>
        </>
      }
      onCancel={closeModal}
      footer={
        <>
          <Button onClick={closeModal}>Отмена</Button>
          <Button type="primary" onClick={form.submit} loading={isLoading}>
            Далее
          </Button>
        </>
      }
    >
      <Form
        form={form}
        onFinish={({ reason }) => {
          submitCancelPayment(reason);
        }}
      >
        <Form.Item name="reason" label="Основание действия">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};
